import * as pagination from '@zag-js/pagination';
import { normalizeProps, useMachine } from '@zag-js/solid';
import { createMemo, createUniqueId } from 'solid-js';
import { useEnvironmentContext, useLocaleContext } from '../../providers';
export const usePagination = (props) => {
    const locale = useLocaleContext();
    const environment = useEnvironmentContext();
    const id = createUniqueId();
    const context = createMemo(() => ({
        id,
        dir: locale().dir,
        getRootNode: environment().getRootNode,
        page: props.defaultPage,
        ...props,
    }));
    const [state, send] = useMachine(pagination.machine(context()), { context });
    return createMemo(() => pagination.connect(state, send, normalizeProps));
};
